import React from "react";
import DatePickerController from "../datePickerController";
import {
  getAdminExtraDateRowLabel,
  getAssessmentAdminExtraDateRows,
  getVqaDateFieldValue,
} from "../../utils/assessmentAdminFormHelpers";

/**
 * Config-driven final-draft / observation date rows for admin assessment detail.
 */
export default function AssessmentAdminExtraDateRows({
  section,
  vqa,
  updateActive,
  control,
  dateFormat,
  hideWhenNoVqa = false,
}) {
  if (hideWhenNoVqa && !vqa) return null;

  const rows = getAssessmentAdminExtraDateRows(section);

  return rows.map((row) => {
    const value = getVqaDateFieldValue(vqa, row.vqaKey);
    return (
      <div
        key={row.id}
        className="px-0 py-4"
        style={hideWhenNoVqa ? { display: !vqa && "none" } : undefined}
      >
        <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
          <h2 className="text-sm font-medium text-gray-900">
            {getAdminExtraDateRowLabel(row)}
          </h2>
          <p className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
            <span>
              {section === "observation" ? (
                updateActive ? (
                  <DatePickerController
                    control={control}
                    fieldName={row.fieldName}
                    value={value}
                    disableMinDate={true}
                  />
                ) : value !== null ? (
                  dateFormat(value)
                ) : (
                  "-"
                )
              ) : (
                <label htmlFor="">
                  {updateActive ? (
                    <DatePickerController
                      control={control}
                      fieldName={row.fieldName}
                      value={value}
                      disableMinDate={true}
                    />
                  ) : value !== null ? (
                    dateFormat(value)
                  ) : (
                    "-"
                  )}{" "}
                </label>
              )}
            </span>
          </p>
        </div>
      </div>
    );
  });
}
